export default {
      id: "ic_bilyoner-usage",
      viewBox: "0 0 20 28",
      url: "/" + "images/icons.3.109.2.svg#ic_bilyoner-usage",
      toString: function () {
        return this.url;
      }
    }